import React from 'react'
import "./about.css"
import ME from "../../assets/bg-focus.gif"
import { FaAward } from "react-icons/fa"
import { FaGraduationCap } from "react-icons/fa"
import { VscFolderLibrary } from "react-icons/vsc"

const About = () => {
  return (
    <section id="about">
      <h5>Get to Know</h5>
      <h2>About Me</h2>

      <div className="container about_container">
          <div className="about_me-image">
             <img src={ME} alt="" />
            
        </div>

        <div className="about_content">
          <div className="about_cards">

            
          <article className='about_card'>
              <FaGraduationCap className='about_icon'/>
              <h5>Education</h5>
              <small>BE - 2022</small>
            </article>

            <article className='about_card'>
              <FaAward className='about_icon'/>
              <h5>Experience</h5>
              <small>3+ Years 
                {/* Working */}
                </small>
            </article>

            <article className='about_card'>
              <VscFolderLibrary className='about_icon'/>
              <h5>Projects</h5>
              <small>Completed</small>
            </article>
            
          </div>

          <p>
          Results-driven Software Engineer with 3+ years of experience building dynamic, responsive web applications using modern JavaScript frameworks. Skilled in both frontend (specialised) and backend technologies, with strong knowledge of React, Node.js, Express.js, and MongoDB. Proven ability to deliver scalable, performant solutions and collaborate cross-functionally with design and engineering teams.
          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About


